import CollapsibleContent from './CollapsibleContent';
import _useScrollHeight from './useScrollHeight';

export const useScrollHeight = _useScrollHeight;
export default CollapsibleContent;
